module.exports = Em.Route.extend({
    model: function(params) {
        return BD.AnonymousRecord.createRecord({
            request: params.request,
            code: params.code,
            password: null
        })
    }
})
